import { LearnosityScores } from './LearnosityScores';
import { SkillStates, SkillSubStates } from './SkillState';

export interface AttemptInformation {
  state?: SkillStates;
  subState?: SkillSubStates;
  scores: { score: number; id: string }[];
  totalScore: number;
}

// Normalizes Learnosity's getScores() map (null = unscored) into the
// AttemptInformation contract. Shared by the real submit path and the
// guided-tour preview submit so the two can never drift.
export const attemptInfoFromScores = (scores: LearnosityScores): AttemptInformation => ({
  scores: Object.entries(scores).map(([id, { score }]) => ({ id, score: score ?? 0 })),
  totalScore: Object.values(scores).reduce((acc, { score }) => acc + (score ?? 0), 0),
});
